import { FormField, TextInput } from 'grommet';

export const Country = (): JSX.Element => {
  return (
    <FormField
      name="country"
      htmlFor="country"
      label="Country"
      required
    >
      <TextInput
        id="country"
        name="country"
        placeholder="Country"
      />
    </FormField>
  );
};
